module.exports = __webpack_public_path__ + "static/media/cofeecup.3c0de2b0.png";